import { useEffect, useState } from 'react'
import { Input } from 'antd'
import { useTranslation } from 'react-i18next'
import { useTableUrlState } from '@/shared/ui/table/useTableUrlState'

/**
 * Qidiruv maydoni — holati MANZILDA.
 *
 * <h2>⚠️ Nega alohida komponent</h2>
 * `DataTable` da qidiruv allaqachon bor, lekin SERVER SAHIFALASHINI
 * qo'llab-quvvatlamaydigan endpointlar `DataTable` ni ishlata olmaydi
 * (to'liq ro'yxat kelganda u qatorlarni MIJOZDA kesardi — bu esa
 * «ko'zbo'yamachilik sahifalash»). Bunday ro'yxatlarda jadval oddiy
 * qoladi, qidiruv esa BIR XIL bo'lishi kerak: bir xil kechikish, bir
 * xil URL parametri (`?q=`), bir xil xulq.
 *
 * Nusxa ko'chirilganda ular jimgina ajralib ketardi — bittasida
 * kechikish bor, boshqasida yo'q; bittasi URL'ga yozadi, boshqasi
 * yo'q.
 *
 * <h2>⚠️ Kechikish `DataTable` nikiga TENG</h2>
 * 350 ms. Ikki xil son ikki ekranda ikki xil "sezgi" berardi va
 * foydalanuvchi buni nosozlik deb o'qirdi.
 *
 * <h2>⚠️ Matn LOKAL holatda, URL'ga faqat TO'XTAGANDA yoziladi</h2>
 * Har harfda URL yozish tarixni ham, kesh kalitini ham shovqinga
 * to'ldirardi.
 */
export function UrlSearchInput({
  placeholder,
  width = 240,
}: {
  placeholder?: string
  width?: number
}) {
  const { t } = useTranslation()
  const { state, patch } = useTableUrlState()
  const [text, setText] = useState(state.search)

  // Tashqaridan (havola, "orqaga", filtr tozalash) o'zgarsa maydon
  // ham yangilanadi — aks holda URL bo'shab, maydonda eski matn qolardi
  useEffect(() => setText(state.search), [state.search])

  useEffect(() => {
    if (text === state.search) return
    const timer = setTimeout(() => patch({ search: text }), 350)
    return () => clearTimeout(timer)
  }, [text, state.search, patch])

  return (
    <Input.Search
      allowClear
      value={text}
      onChange={(e) => setText(e.target.value)}
      placeholder={placeholder ?? t('dataTable.searchPlaceholder')}
      style={{ width, maxWidth: '100%' }}
    />
  )
}
